module.exports = (__webpack_require__(0))(518);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/TimelineWidget.js from dll-reference girder_lib
// module id = 23
// module chunks = 0